<p-messages id="growl" [(value)]="_messageService.messages"></p-messages>

<p-confirmDialog acceptLabel="Sim" width="425" rejectLabel="Não" #cd>
  <footer>
    <button id="nao" type="button" pButton icon="fa-close" label="Não" (click)="cd.reject()"></button>
    <button id="sim" type="button" pButton icon="fa-check" label="Sim" (click)="cd.accept()"></button>
  </footer>
</p-confirmDialog>

<!--
BODY TAG OPTIONS:
=================
Apply one or more of the following classes to get the
desired effect
|---------------------------------------------------------|
| SKINS         | skin-blue (PADRAO)                      |
|               | skin-black (CRIADA)
|               | skin-blue-white (CRIADA)                |
|---------------------------------------------------------|
|LAYOUT OPTIONS | fixed                                   |
|               | layout-boxed                            |
|               | layout-top-nav                          |
|               | sidebar-collapse                        |
|               | sidebar-mini                            |
|---------------------------------------------------------|
-->

<!-- <body class="hold-transition skin-blue sidebar-mini"> -->
<!-- <div class="wrapper" >-->

<!-- Main Header  Cabecaçalho -->
<!-- 
<header class="main-header" *ngIf="authService.isLoggedIn">  
  <a href="#" class="logo">       
    <span class="logo-mini">      
      <img class="responsive-img" src="../assets/img/logo/icon/logo-icon.png">   
    </span>   
    <span class="logo-lg">
      <img class="responsive-img" src="../assets/img/logo/pequeno/logo.png">
    </span>
  </a>
    <nav class="navbar navbar-static-top" role="navigation">    
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button" (click)="toggleMenu()">
        <span class="sr-only">Toggle navigation</span>
      </a>    
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav" style="padding-top: 6px;">
          <li class="dropdown messages-menu">
            <a data-toggle="control-sidebar">
              {{ globalsVariablesService.nomeLoja}}
            </a>
          </li>
          <li class="dropdown messages-menu">
            <a href="https://api.whatsapp.com/send?phone=5562996360547&text=Enviando%20mensagem" target="_blank"
              style="cursor: pointer">
              <i class="fa fa-whatsapp" style="font-size: 21px;"></i></a>
          </li>

          <li *ngIf="globalsVariablesService.isRepresentante" class="dropdown messages-menu">
            <a routerLink="/administrativo/representante">
              <i class="fi-dashboard-opening-email"></i>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.isRepresentante" class="dropdown messages-menu">
            <a routerLink="/administrativo/boleto-cliente">
              <i class="fi-dashboard-dashboard"></i>
            </a>
          </li>

          <li>
            <a (click)="logout()" data-toggle="control-sidebar">
              <i class="fa fa-power-off"></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
</header>
 -->
<!-- Left side column. contains the logo and sidebar -->

<aside id="menuLateral" *ngIf="authService.isLoggedIn" [ngClass]="toggleIsOpen ? 'menuLateralAberto' : 'menuLateralFechado'">
  
  <div style="padding: 10px;margin-bottom: 29px;" >
    <a class="sidebar-toggle" data-toggle="push-menu" role="button"  style="font-size: 20px;" (click)="toggleMenu()">
      <span ><i class="fa fa-bars" aria-hidden="true"></i>
      </span>
    </a>
    <a class="logo" style="margin-left: 25px;" *ngIf="toggleIsOpen">
      <span class="logo-lg" >
        <!-- <img class="responsive-img" src="../assets/img/logo/pequeno/logo.png"> -->
        <img class="responsive-img" [src]="secondaryLogo">
      </span>
    </a>

    <!-- <span style="background-color:#071c4d; height: 100px;" >
      <h5 style=" background-color: #071c4d; color: white;">  {{ globalsVariablesService.nomeLoja}} </h5>
    </span>   -->
 </div>

    

  <!-- sidebar: style can be found in sidebar.less -->
  <section>


    <!-- Sidebar user panel (optional) -->
    <div class="subMenuTitulo" (click)="fecharSubMenu()" *ngIf="(subMenuAberto && toggleIsOpen)">
       <span> ⇦ </span> <span> {{subMenuTitulo}}</span>
     </div>       

     <!--
        <div class="pull-left image">
          <img src="{{globalsVariablesService.getUsuarioLogado.caminhoImagem}}" class="img-circle" alt="User Image">
        </div>
        <div class="pull-left info">
          <p><span>Olá</span>,<br>{{globalsVariablesService.getUsuarioLogado.pessoaNomeFantasia}}</p>
          
          <a href="#">
            <i class="fa fa-circle text-success"></i> Online</a>
        </div>
        </div>
      -->

    <!-- search form (Optional)
      <form action="#" method="get" class="menu-search sidebar-form">
        <div class="input-group">        
        </div>
      </form> 
    -->
    <!-- /.search form -->

    <!-- Sidebar Menu -->        
    
    <ul [ngClass]="subMenuAberto ? 'menuFechado' : 'menuAberto'">

      <li class="subMenuItem" (click)=" onClickDashboard();">
        <a  routerLink="/dashboard" >
          <i class="rota fi-dashboard-graphic" style="display: inline;"></i>
          <span *ngIf="!subMenuAberto"> Dashboard </span>
        </a>
      </li>

      <li *ngIf="globalsVariablesService.visualizarModulo('cadastros')" class="subMenuItem" (click)="abrirSubMenu('cadastros', 'Cadastros', 1)">
        <a>
          <i class="fi-dashboard-rounded-paper-with-text-lines-and-one-folded-corner"></i>
          <span *ngIf="!subMenuAberto">Cadastros</span>
        </a>

        <ul  [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'cadastros'" >
          <li *ngFor="let relatorio of globalsVariablesService.getFuncionalidadesVisiveis('cadastros')">
            <a class="rota" [routerLink]="relatorio.rota">
              <span class="rota icon">{{ relatorio.descricao }}</span>
            </a>
          </li>

        </ul>
      </li>



      <li *ngIf="globalsVariablesService.visualizarModulo('vendas')" class="subMenuItem" (click)="abrirSubMenu('vendas', 'Vendas', 2)">
        <a>
          <i class="fi-ecommerce-shopping-cart-8"></i>
          <span *ngIf="!subMenuAberto">Vendas</span>
        </a>

        <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'vendas'" >
          <li *ngIf="globalsVariablesService.visualizar('vendas', 'pedido')">
            <a class="rota" routerLink="/comercial/pedido">
              <span class="rota icon"> Pedido </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('vendas', 'pdv')">
            <a class="rota" routerLink="/comercial/pdv">
              <span class="rota icon"> PDV </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('vendas', 'nfse')">
            <a class="rota" routerLink="/comercial/nfse">
              <span class="rota icon"> NFSE </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('vendas', 'cancelamentoPedido')">
            <a class="rota" routerLink="/comercial/cancelamento-pedido">
              <span class="rota icon"> Cancelamento Pedido</span>
            </a>
          </li>

          <hr/>
        
          <li *ngIf="globalsVariablesService.visualizar('vendas', 'devolucaoCliente')">
            <a class="rota" routerLink="/comercial/devolucao-cliente">
              <span class="rota icon">Devolução Cliente </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('vendas', 'importacaoExportacao')">
            <a class="rota" routerLink="/comercial/importacao-exportacao">
              <span class="rota icon">Importação & Exportação </span>
            </a>
          </li>

          <hr/>


          <li *ngIf="globalsVariablesService.visualizar('vendas', 'contrato')">
            <a class="rota" routerLink="/administrativo/contrato">
              <span class="rota icon">Contrato </span>
            </a>
          </li>


        </ul>
      </li>


       <li *ngIf="globalsVariablesService.visualizarModulo('compras')" class="subMenuItem" (click)="abrirSubMenu('compras', 'Compras',3)">
          <a>
            <i class="fi-ecommerce-trolley"></i>
            <span *ngIf="!subMenuAberto && toggleIsOpen">Compras</span>          
          </a>

          <ul  [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'compras'">
            <li *ngIf="globalsVariablesService.visualizar('compras', 'importacaoCompraXML')">
              <a class="rota" routerLink="/comercial/importacao-compra">
                <span class="rota icon">  Importação de XML </span>
              </a>
            </li>
            <li *ngIf="globalsVariablesService.visualizar('compras', 'pedidoCompra')">
              <a class="rota" routerLink="/comercial/pedido-compra">
                <span class="rota icon"> Pedido de Compra </span>
              </a>
            </li>
            <hr/>
            <li *ngIf="globalsVariablesService.visualizar('compras', 'devolucaoFornecedor')">
              <a class="rota" routerLink="/comercial/devolucao-fornecedor">
                <span class="rota icon"> Devolução Fornecedor </span>
              </a>
            </li>
        </ul>
      </li>

      <li *ngIf="globalsVariablesService.visualizarModulo('fiscal')" class="subMenuItem" (click)="abrirSubMenu('fiscal', 'Fiscal',4)">
        <a>
          <i class="fi-ecommerce-pen"></i>
          <span *ngIf="!subMenuAberto">Fiscal</span>
        </a>

        <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'fiscal'">
          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'grupoTributoProduto')">
            <a class="rota" routerLink="/fiscal/grupo-tributo-produto">
              <span class="rota icon">Grupo Tributo Produto </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'ncm')">
            <a class="rota" routerLink="/fiscal/ncm">
              <span class="rota icon"> NCM </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'nbs')">
            <a class="rota" routerLink="/fiscal/nbs">
              <span class="rota icon"> NBS </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'configuracaoTributo')">
            <a class="rota" routerLink="/fiscal/configuracao-tributo">
              <span class="rota icon">Configuração Tributo </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'operacao')">
            <a class="rota" routerLink="/fiscal/operacao">
              <span class="rota icon"> Operação </span>
            </a>
          </li>

          <hr/>
          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'inutilizacaoNFCENFE')">
            <a class="rota" routerLink="/comercial/inutilizacao">
              <span class="rota icon"> Inutilização NFCE/NFE</span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'cartaCorrecao')">
            <a class="rota" routerLink="/comercial/carta-correcao">
              <span class="rota icon">Carta de Correção </span>
            </a>
          </li>
          
          <li *ngIf="globalsVariablesService.visualizar('fiscal', 'espacoContador')">
            <a class="rota" routerLink="/fiscal/espaco-contador">
              <span class="rota icon">Espaço do Contador</span>
            </a>
          </li>

          <hr/>
          <li>
            <a class="rota" routerLink="/paf-nfce/identificacao-software">
              <span class="rota icon">Dados Software House </span>
            </a>
          </li>

          <li>
            <a class="rota" routerLink="/paf-nfce/gerar-paf-nfce">
              <span class="rota icon">   Gerar Arquivo PAF NFCe </span>
            </a>
          </li>


        </ul>
      </li>

      <li *ngIf="globalsVariablesService.visualizarModulo('seguranca')" class="subMenuItem" (click)="abrirSubMenu('seguranca', 'Segurança', 5)">
        <a> 
          <i class="fi-ecommerce-padlock"></i>
          <span *ngIf="!subMenuAberto">Segurança</span>
        </a>
        
        <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'seguranca'">

          <li *ngIf="globalsVariablesService.visualizar('seguranca', 'permissao')">
            <a class="rota" routerLink="/seguranca/permissao">
                <span class="rota icon">  Permissões </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('seguranca', 'usuario')">
            <a class="rota" routerLink="/seguranca/usuario">
              <span class="rota icon">  Usuário </span>
            </a>
          </li>

          <li *ngIf="globalsVariablesService.visualizar('seguranca', 'trocarSenha')">
            <a class="rota" routerLink="/seguranca/trocar-senha">
              <span class="rota icon"> Trocar Senha </span>
            </a>
          </li>

        </ul>
      </li>

      <li *ngIf="globalsVariablesService.visualizarModulo('financeiro')" class="subMenuItem" (click)="abrirSubMenu('financeiro', 'Financeiro', 6)">
        <a>
          <i class="fi-ecommerce-money"></i>
          <span *ngIf="!subMenuAberto">Financeiro</span>          
        </a>
        
        <ul [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'" *ngIf="subMenuAberto == 'financeiro'">

          <li *ngFor="let relatorio of globalsVariablesService.getFuncionalidadesVisiveis('financeiro')">
            <a class="rota" [routerLink]="relatorio.rota">
              <span class="rota icon">{{ relatorio.descricao }}</span>
            </a>
          </li>
        </ul>
      </li>

      <li *ngIf="globalsVariablesService.visualizarModulo('relatorio')" class="subMenuItem" (click)="abrirSubMenu('relatorios', 'Relatórios', 7)">
        <a>
          <i class="fi-dashboard-pie-graphic"></i>
          <span *ngIf="!subMenuAberto">Relatórios</span>
        </a>
        
        <ul  [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'relatorios'">
          
          <li *ngFor="let relatorio of globalsVariablesService.getFuncionalidadesVisiveis('relatorio')">
            <a class="rota" [routerLink]="relatorio.rota">
              <span class="rota icon">{{ relatorio.descricao }}</span>
            </a>
          </li>
  
        </ul>
      </li>

      <li *ngIf="globalsVariablesService.visualizarModulo('configuracoes')" class="subMenuItem" (click)="abrirSubMenu('configuracoes', 'Configurações', 8)">
        <a>
          <i class="fi-dashboard-star-badge-symbol-outline"></i>
          <span *ngIf="!subMenuAberto">Configurações</span>
        </a>
        <ul  [ngClass]="subMenuAberto ? 'subMenuAberto' : 'subMenuFechado'"  *ngIf="subMenuAberto == 'configuracoes'">
            <li *ngFor="let relatorio of globalsVariablesService.getFuncionalidadesVisiveis('configuracoes')">
              <a class="rota" [routerLink]="relatorio.rota">
                <span class="rota icon">{{ relatorio.descricao }}</span>
              </a>
          </li>
        </ul> 
      </li> 

      <li class="subMenuItem" style="padding-left: 15px;" (click)="logout()">
        <a>
          <i class="fa fa-power-off"></i>
          <span >Sair</span>
        </a>
    </li>   

    </ul>
    <div *ngIf="globalsVariablesService.isRepresentante" style="left: 50px; bottom: 10px; position: fixed;">
      <a routerLink="/administrativo/representante">
        <i class="fa fa-users" style="font-size: 35px;"></i>
      </a>  
    </div>
    
    <div style="left: 5px; bottom: 10px; position: fixed;">
      <a [href]="getWhatsappUrl()" target="_blank" style="cursor: pointer">
        <i class="fa fa-whatsapp" style="font-size: 35px;"></i>
      </a>
    </div>
    <!-- /.sidebar-menu -->
  </section>
  <!-- /.sidebar -->
</aside>

<!-- Content Wrapper. Contains page content -->
<div id="container-principal" [ngClass]="{'container-mr7': authService.isLoggedIn}">
  <!-- Content Header (Page header) -->
  <!--
          <section class="content-header">
            <h1>
              Page Header
              <small>Optional description</small>
            </h1>
            <ol class="breadcrumb">
              <li><a href="#"><i class="fa fa-dashboard"></i> Level</a></li>
              <li class="active">Here</li>
            </ol>
          </section> -->

  <!-- Main content -->
  <section class="content">

    <router-outlet>

    </router-outlet>

  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->

<!-- Main Footer -
    <footer class="main-footer" *ngIf="authService.isLoggedIn" >

      <div class="pull-right hidden-xs">
        ..
      </div>
      <!-- Default to the left
      <strong>Copyright &copy; 2016 <a href="#">MR7 TI</a>.</strong>todos os direitos reservados.

    </footer>  -->

<!-- /.control-sidebar -->
<!-- Add the sidebar's background. This div must be placed
       immediately after the control sidebar -->

<div class="control-sidebar-bg" *ngIf="authService.isLoggedIn"></div>

<!-- </div> ./wrapper -->

<!-- REQUIRED JS SCRIPTS -->

<!-- jQuery 2.2.0 -->
<!-- Optionally, you can add Slimscroll and FastClick plugins.
     Both of these plugins are recommended to enhance the
     user experience. Slimscroll is required when using the
     fixed layout. -->
<!--</body> -->